import React, { useEffect } from 'react'
import Table from '../../../components/Common/Table'
import TableNoRecords from '../../../components/Common/Table/TableNoRecords'
import Pagination from '../../../components/Pagination'
import PortfolioContainer from '../../../components/Portfolio/PortfolioContainer'
import SearchFilter from '../../../components/Portfolio/SearchFilter'
import { Context } from '../../../config/store'
import { eligibleForLender, productName, productType } from '../../../constant/selectOptions'
import LenderUgroService from '../../../services/lender'
import TableColumns from './TableColumns'
import './index.css'
import Button from '../../../components/Common/Button'
import { downloadFile } from '../../../common/download'
import objectToQueryParams from '../../../common/objectToQueryParams'

const QueryPending = () => {

  const selectedColender = localStorage.getItem('selectedColender')
  let sessionStorageData = JSON.parse(sessionStorage.getItem('searchData')) || {};
  let { org_page = 1 } = sessionStorageData;
  const queryString = objectToQueryParams(sessionStorageData);
  const [queryParams, setQueryParams] = React.useState(queryString);
  const [page, setCurrentPage] = React.useState(org_page);
  const [pagination, setPagination] = React.useState({});
  const [tableData, setTableData] = React.useState([])
  const [loading, setLoading] = React.useState(true)
  const { state, dispatch } = React.useContext(Context);
  const [excelLoader, setexcelLoader] = React.useState(false);
  const [isSubmitClicked, setIsSubmitClicked] = React.useState(false)
  const [sortParams, setSortParams] = React.useState({
    sortBy: '',
    sortOrder: '',
  });
  React.useEffect(() => {
    dispatch({
      type: 'selectedColender',
      selectedColender: '/portfolio/query-pending',
    });
    localStorage.setItem('selectedColender', '/portfolio/query-pending');
  }, []);

  useEffect(() => {
    getPendingQueries()
  }, [page])
  useEffect(() => {
    if (!loading) getPendingQueries(true)
  }, [queryParams])

  const getPendingQueries = async (paramsChanged, exportCount, sortBy, sortOrder) => {
    // alert(true)
    setLoading(true);
    try {
      const response = await LenderUgroService.getListOfPendingQueries({
        page: paramsChanged ? 1 : page,
        queryParams,
        exportCount,
        sortBy: sortBy ? sortBy : sortParams.sortBy,
        sortOrder: sortOrder ? sortOrder : sortParams.sortOrder,
      });
      const data = response.data.data?.cl_leads?.data;
      setTableData(data || [])
      setCurrentPage(page);
      // Update session storage data if page changed
      let searchDataNew = { ...sessionStorageData, org_page: (paramsChanged ? 1 : page) }
      sessionStorage.setItem('searchData', JSON.stringify(searchDataNew))
      setPagination(response?.data?.data?.cl_leads?.pagination || {});
      if (exportCount == 1) {
        downloadFile(response.data, "Query_pending" + new Date().toLocaleDateString())
        getPendingQueries()
      }
      setLoading(false)
    } catch (err) {
      console.log("error ", err);
    }
  };
  const onSortChange = ({ sortOrder, sortBy }) => {
    setSortParams({ sortBy, sortOrder });
    getPendingQueries(0, false, sortBy, sortOrder)
  };
  return (
    <PortfolioContainer>
      <SearchFilter
        setQueryParams={setQueryParams}
        productTypes={productType}
        productNames={productName}
        lenders={eligibleForLender}
        statusOptions={[
          { label: 'Unassigned', value: 1 },
          { label: 'Additional Info Pending', value: 2 },
          {
            label: 'Doc Pending',
            value: 3,
          },

          { label: 'Pulled Back', value: 8 },
        ]}
        loading={loading}
      ></SearchFilter>
      <div className='d-flex justify-content-end'>
        {excelLoader ? <Button classNames='excelDownloadLoader my-3'> <div className="loader"></div></Button> :
          <Button
            type='btn-export'
            classNames='float-right text-white mt-2 mb-2'
            clickHandler={() => getPendingQueries(queryParams, 1)}
          >
            <i class="fa fa-file-excel-o mr-1" aria-hidden="true"></i>
            Export Excel
          </Button>
        }
      </div>
      <div className='query_pending'>
        <Table
          columns={TableColumns}
          rows={tableData || []}
          loading={loading}
          onSortChange={onSortChange}
        >
          {Boolean(!tableData.length) && <TableNoRecords />}
        </Table>
      </div>

      <div className="my-2">
        {pagination?.total_pages ? (
          <Pagination
            // disabled={loading}
            setPage={setCurrentPage}
            total_pages={pagination.total_pages}
            total={pagination.total}
          />
        ) : (
          ''
        )}
      </div>
    </PortfolioContainer>
  )
}

export default QueryPending